/**
 * This plugin replicates the old $sso functionality from the old auth plugin
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { $localeRootPath } = nuxtApp;

  /**
   * Process redirect for SSO or checkout
   */
  const processOWRedirect = (redirect, context) => {
    if (redirect === 'checkout') {
      context.store
        .dispatch('cart/checkoutUrl')
        .then((url) => {
          window.localStorage.removeItem('ow:redirect');
          window.open(url, '_self');
        })
        .catch((e) => {
          console.warn('could not login to shopify');
          return false;
        });

      return $localeRootPath('/processing');
    } else if (redirect === 'learnworlds') {
      const redirectUrl = window.localStorage.getItem('ow:redirectUrl');

      window.localStorage.removeItem('ow:redirect');
      window.localStorage.removeItem('ow:redirectUrl');

      // Call the learnworlds SSO endpoint - we'll need to create this
      $fetch('/api/auth/learnworlds-sso', {
        method: 'POST',
        body: { redirectUrl },
      })
        .then((response) => {
          if (response.success && response.url) {
            window.open(response.url, '_self');
          }
        })
        .catch((e) => {
          console.warn('could not login to learnworlds');
          return false;
        });

      return $localeRootPath('/processing');
    }
  };

  // Expose methods to the app
  return {
    provide: {
      sso: {
        processOWRedirect,
      },
    },
  };
});
